export default __webpack_public_path__ + "static/media/mobile_search_black.2989cef0.svg";